import { Component, OnInit, Inject } from '@angular/core';
import {MatDialog, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';
import { SnackbarService } from 'src/app/snackbar.service';

import {Messages} from '../../constants/messages'
import { HttpService } from 'src/app/http.service';
import { EventService } from 'src/app/event.service';
import { ValidationService } from 'src/app/validation.service';

export interface Bid {
  order: string;
  auto: boolean;
  amount: any;
  floor_amount?: number
  decrement_amount?: number;
}

@Component({
  selector: 'app-bid-details-modal',
  templateUrl: './bid-details-modal.component.html',
  styleUrls: ['./bid-details-modal.component.scss']
})
export class BidDetailsModalComponent implements OnInit {
  currency = 'Rs';
  currencySymbol;
  carrierId;
  rules: any;
  accepted: boolean;
  selectedOrderData: any;
  min_bid_diff:number;
  max_bid_amount:number;//maximum bid amount i.e lowest bid amount - minimum bid difference


  bidData: Bid = {
    order: '',
    auto: false,
    amount: 0
  };

  lastBids = {
    last_bid: 0,
    bids: []
  };
  isBidOrderExpired = false;

  messages =new Messages();


  constructor(public dialogRef: MatDialogRef<BidDetailsModalComponent>,@Inject(MAT_DIALOG_DATA) public data,public snackbar:SnackbarService,
  private http: HttpService, private events: EventService,private valid:ValidationService) { }

  ngOnInit() {
    console.log("data received", this.data)

    const currency = JSON.parse(localStorage.getItem('carriers'));
    this.currencySymbol = currency[0].country.currency.symbol;
    this.carrierId = this.events.getCarrierIdChanges().subscribe(
      (data: any) => {
        const rupee = JSON.parse(localStorage.getItem('carriers'));
        this.currencySymbol = rupee[0].country.currency.symbol;
      },
      (err: any) => {
        console.log('Err ::', err);
      }
    );

    this.events.bidUpdateChanges().subscribe((data)=>{
      if(data.code == 412){
        this.selectedOrderData.lowest_bid_amount = data.amount;
        this.max_bid_amount = parseInt(this.selectedOrderData.lowest_bid_amount) - parseInt(this.selectedOrderData.min_bid_diff);
      }
    })

    this.events.BidOrderStopped().subscribe((data)=>{
      if(data.code == 412){
        this.isBidOrderExpired = true;
      }
    })


    this.selectedOrderData = this.data;
    this.bidData.order = this.selectedOrderData._id;
    this.min_bid_diff = parseInt(this.selectedOrderData.min_bid_diff);
    this.max_bid_amount = parseInt(this.selectedOrderData.lowest_bid_amount) - parseInt(this.selectedOrderData.min_bid_diff);//maximum bid amount i.e lowest bid amount - minimum bid difference
    this.bidData.amount = this.max_bid_amount - 1;
    if(this.data.bid_flow == 'rfq'){
      this.bidData.amount = '';
    }
    this.getBidRules();
  }

  getFormattedArea(area: string): string {
    const index = area.lastIndexOf(", India");
    return index !== -1 ? area.substring(0, index) : area;
  }

  bid() {
  
    let valid = true;
    if (!this.bidData.auto) {//auto bid set to false
      if (this.bidData.amount < 1) {
        valid  = false;
        this.snackbar.openSnackBar(this.messages.BID_ORDERS.ERROR.AMOUNT, '', 'err');
      }
      if(this.bidData.amount > 1){
        if(!this.valid.isNumber(this.bidData.amount)){
          valid  = false;
          this.snackbar.openSnackBar(this.messages.BID_ORDERS.ERROR.NOT_INTEGER_AMT, '', 'err');
        }
      }
    } else {//auto bid is set to true
      if (!this.bidData.amount || this.bidData.amount < 1) {
        valid = false;
        this.snackbar.openSnackBar(this.messages.BID_ORDERS.ERROR.AMOUNT, '', 'err');
      }
      if(this.bidData.amount > 1){
        if(!this.valid.isNumber(this.bidData.amount)){
          valid  = false;
          this.snackbar.openSnackBar(this.messages.BID_ORDERS.ERROR.NOT_INTEGER_AMT, '', 'err');
        }
      }
      if (!this.bidData.floor_amount || this.bidData.floor_amount < 1) {
        valid = false;
        this.snackbar.openSnackBar(this.messages.BID_ORDERS.ERROR.FLOOR_AMOUNT, '', 'err');
      }
      if(this.bidData.floor_amount > 1){
        if(!this.valid.isNumber(this.bidData.floor_amount)){
          valid  = false;
          this.snackbar.openSnackBar(this.messages.BID_ORDERS.ERROR.NOT_INTEGER_FLOOR_AMT, '', 'err');
        }
      }
      if (Number(this.bidData.floor_amount) > Number(this.bidData.amount)) {//floor amount should be less than the bid amount
        valid = false;
        this.snackbar.openSnackBar(this.messages.BID_ORDERS.ERROR.FLOOR_AMOUNT_GREATER, '', 'err');
      }
      if (!this.bidData.decrement_amount || this.bidData.decrement_amount < 1) {
        valid = false;
        this.snackbar.openSnackBar(this.messages.BID_ORDERS.ERROR.DECREMENT_VALUE, '', 'err');
      }
      if(this.bidData.decrement_amount > 1){
        if(!this.valid.isNumber(this.bidData.decrement_amount)){
          valid  = false;
          this.snackbar.openSnackBar(this.messages.BID_ORDERS.ERROR.NOT_INTEGER_DECREMENT_AMT, '', 'err');
        }
      }
    }

    if (valid) {
      if(this.data.bid_flow=='tender'){
        this.http.post('v1/tender', {"amount":this.bidData.amount, "order":this.bidData.order}).subscribe(
          (res:any)=>{
            if (res.statusCode == 200) {

              this.snackbar.openSnackBar(this.messages.BID_ORDERS.SUCCESS.BID);
              this.bidData.amount = 0;
              this.dialogRef.close(res);

              // this.bidData.floor_amount = 0;
              // this.bidData.decrement_amount = 0;
            }
          },
          (err) => {
            this.snackbar.openSnackBar(err.error.message, '', 'err');
            // if (err.error.statusCode == 420) {
            //   this.showManualDialog();
            // }
          }
        )
      }
      else{
        this.http.post('order/bid', this.bidData).subscribe(
          (response: any) => {
            if (response.statusCode == 200) {

              this.snackbar.openSnackBar(this.messages.BID_ORDERS.SUCCESS.BID);
              this.bidData.amount = 0;
              this.dialogRef.close(response);

              // this.bidData.floor_amount = 0;
              // this.bidData.decrement_amount = 0;
            }
          },
          (err) => {
            this.snackbar.openSnackBar(err.error.message, '', 'err');
            // if (err.error.statusCode == 420) {
            //   this.showManualDialog();
            // }
          }
        );
      }
    }
  }

  onChange(event){
    if(!event.checked){// Clear the bid data
      this.bidData.decrement_amount = undefined;
      this.bidData.floor_amount = undefined;
    }
  }

  close(){
    if(this.isBidOrderExpired){
      this.dialogRef.close({code:412});
    }else{
      this.dialogRef.close();
    }
  }

  ngOnDestroy() {
    this.carrierId.unsubscribe();
  }

  getBidRules() {
    const payload = { 
      shipper: this.selectedOrderData.shipper._id,
    };
    this.http.get("v1/bidOrderRules", payload).subscribe(
      (data: any) => {
        if (data.statusCode === 200) {
          this.rules = data.data;
        }
      },
      (err: any) => {
        this.snackbar.openSnackBar(err.error.message, "", "err");
      }
    );
   
  }

}
